import React from "react";
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer";
import { useForm ,Controller} from "react-hook-form";
import PhoneInput from 'react-phone-number-input';
import './contact_style.css'
import { Link } from "react-router-dom";
const PressMedia = ()=> {
      const {
        
        register,
        handleSubmit,
        control,
        formState: { errors },
      } = useForm();
    
      
    
      const onSubmit = (data) => {
        console.log(data);
        // Handle form submission
      };
    return (
        <>
          <AIheader/>
            <section className="contactPageMain" id="">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {/* START Left Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactPageLeft">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link href="/contact-us">Contact Us</Link></li>
                                    <img className="" src="/img/arrow-right-nav.svg" alt="arrow icon"/>
                                    <li className="breadcrumb-item active" aria-current="page">Press & Media</li>
                                </ol>
                            </nav>
                            <h2>Press & Media</h2>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="mb-4">
                                            <label className="form-label">First Name</label>
                                            <input
                                            type="text"
                                            {...register("firstName", { required: true })}
                                            className="form-control"
                                            placeholder="Enter first name"
                                            />
                                            {errors.firstName && (
                                            <div className="text-danger small">First Name is required</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mb-4">
                                            <label className="form-label">Last Name</label>
                                            <input
                                            type="text"
                                            {...register("lastName", { required: true })}
                                            className="form-control"
                                            placeholder="Enter last name"
                                            />
                                            {errors.lastName && (
                                            <div className="text-danger small">Last Name is required</div>
                                            )}
                                        </div>
                                    </div>
                                    

                                    <div className="col-lg-6">
                                        <div className="mb-4">
                                            <label className="form-label">Email Address</label>
                                            <input
                                            type="email"
                                            {...register("email", { required: true })}
                                            className="form-control"
                                            placeholder="Enter your email"
                                            />
                                            {errors.email && (
                                            <div className="text-danger small">Email is required</div>
                                            )}
                                        
                                        </div>
                                    </div>

                                    <div className="col-lg-6">  
                                        <div className="mb-4">
                                            <label className="form-label">Phone Number</label>
                                            <Controller
                                            name="phone"
                                            control={control}
                                            rules={{
                                                required: "Phone number is required",
                                                validate: (value) => (value && value.length >= 10) || "Phone number must be valid",
                                            }}
                                            render={({ field }) => (
                                                <PhoneInput
                                                {...field}
                                                id="phone_number"
                                                limitMaxLength="10"
                                                defaultCountry="US"
                                                placeholder="XXX-XXX-XXX"
                                                onChange={(value) => field.onChange(value)} // Ensure React Hook Form value updates
                                                value={field.value || ''}
                                                />
                                            )}
                                            />
                                            {errors.phone && (
                                            <div className="text-danger small">{errors.phone.message}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="mb-4">
                                            <label className="form-label">Message</label>
                                            <textarea
                                            {...register("message", { required: true })}
                                            className="form-control"
                                            placeholder="Let us know how we can assist you today..."
                                            rows="4"
                                            ></textarea>
                                            {errors.message && (
                                            <div className="text-danger small">Message is required</div>
                                            )}
                                        </div>
                                    </div>

                                    {/* <div className="col-lg-12">
                                        <div className="form-check mb-4">
                                            <input
                                            type="checkbox"
                                            {...register("privacyPolicy", { required: true })}
                                            className="form-check-input"
                                            id="privacyPolicy"
                                            />
                                            <label className="form-check-label" htmlFor="privacyPolicy">
                                            I agree with the Rentii Privacy Policy.
                                            </label>
                                            {errors.privacyPolicy && (
                                            <div className="text-danger small">Required</div>
                                            )}
                                        </div>
                                    </div> */}

                                    <div className="col-lg-12">
                                        <button type="submit" className="btn submit w-100">Submit</button>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                        {/* END Left Section */}

                        {/* START Right Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactPageRight">
                                <div className="contactPageRightInner">
                                    <h2>We’re here to help.</h2>
                                    <p>Workflows and tools built to help your rental business thrive. Let us know how we can assist you.</p>
                                </div>
                                
                                <div className='contactLogoOuter'>
                                    <div className="contactLogoInner contactLogoGreen">
                                        <a href="/rentdirect">
                                        <div className="green_overlay"></div>
                                            <figure><img src="/img/rent_direct_logo.png" alt="logo"/></figure>
                                        </a>
                                    </div>
                                    
                                    <div className="contactLogoInner contactLogoSky">
                                        <a href="/rentid">
                                            <div className="sky_overlay"></div>
                                            <figure> <img src="/img/rent_id_logo.svg" alt="logo"/></figure>
                                        </a>
                                    </div>

                                    <div className="contactLogoInner contactLogoRed">
                                        <a href="/rentshield">
                                            <div className="red_overlay"></div>
                                            <figure><img src="/img/rent_shield_logo.png" alt="logo"/></figure>
                                        </a>
                                    </div>
            
                                    <div className="contactLogoInner contactLogoPurple">
                                        <a href="/rentsuccess">
                                            <div className="purple_overlay"></div>
                                            <figure><img src="/img/rent_success_logo.png" alt="logo"/></figure>
                                        </a>
                                    </div>


                                    <div className="contactLogoInner contactLogowhite">
                                        <a href="/rentai">
                                            <div className="white_overlay"></div>
                                            <figure> <img src="/img/rent_ai_logo.svg" alt="logo"/></figure>
                                        </a>
                                    </div>
                                    <div className="contactLogoInner contactLogoYellow">
                                        <a href="/rentacademy">
                                            <div className="yellow_overlay"></div>
                                            <figure> <img src="/img/rent_academy_logo.png" alt="logo"/></figure>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* END Right Section */}
                    </div>
                </div>
            </section>
        <Footer/>
        </>
    )
}
export default PressMedia;